import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  availabilityOptions: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  availabilityChip: {
    margin: theme.spacing(0, 3.5, 1.5, 0),
  },
}))
